var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a7fb0d646771161b5e42c4501ecf0e6526ae289f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sso-next@algolift"]={id:"a7fb0d646771161b5e42c4501ecf0e6526ae289f"};
      